angular
  .module('fca-used')
  .factory('uvl', uvlService);

uvlService.$inject = ['$window', '$http', '$sce', '$httpParamSerializer', '$q', '$translate', '$localStorage', 'asyncTasks', 'ResultHelper', 'mergeSort', 'CONFIG', 'BREAKPOINTS'];

function uvlService($window, $http, $sce, $httpParamSerializer, $q, $translate, $localStorage, asyncTasks, ResultHelper, mergeSort, CONFIG, BREAKPOINTS) {
  var baseUrl = CONFIG.uvl.api;
  var lastDealerList = [];
  var lastDealerListParams = {};

  return {
    request: request,
    getLastQuery: getLastQuery,
    saveLastQuery: saveLastQuery,
    getLastFilters: getLastFilters,
    saveLastFilters: saveLastFilters,
    getValues: getValues,
    getVehicles: getVehicles,
    getVehiclesCount: getVehiclesCount,
    getVehicleDetails: getVehicleDetails,
    getShareUrl: getShareUrl,
    getDealer: getDealer,
    getDealerList: getDealerList,
    getConsumer: getConsumer,
    getImpressum: getImpressum
  };

  function getLastQuery() {
    return angular.copy($localStorage.lastQuery);
  }

  function saveLastQuery(query) {
    $localStorage.lastQuery = query;
  }

  function getLastFilters() {
    return $localStorage.lastFilters;
  }

  function saveLastFilters(filters) {
    $localStorage.lastFilters = filters;
  }

  function getConsumer() {
    if ($window.innerWidth < BREAKPOINTS.DESKTOP.MIN) {
      return 'MOBILE';
    }
    return 'DESKTOP';
  }

  function buildQuery(query, fields, groups, order) {
    // query.filters.vehicleType =['U'];
    if (query.location && query.location.city) {
      delete query.location.city;
    }
    var q = {
      consumer: getConsumer(),
      scope: 'NET',
      query: query,
      options: {
        culture: CONFIG.language.id + '_' + CONFIG.market.id.toUpperCase(),
        stats: 'true'
      }
    };
    if (fields) {
      q.fields = fields;
    }
    if (groups) {
      q.groups = groups;
    }
    if (order) {
      q.order = order;
    }
    return q;
  }

  function prepareFilter(filterName, filters) {
    switch (filterName) {
      case 'km':
        filters.km = [
          CONFIG.search.mileage.min + ' TO ' +
        filters.km
        ];
        break;
      case 'priceCurrent':
        filters.priceCurrent = [
          filters.priceCurrent.min + ' TO ' +
        filters.priceCurrent.max
        ];
        break;
      case 'registrationYear':
        filters.registrationYear = [
          filters.registrationYear.min + ' TO ' +
        filters.registrationYear.max
        ];
        break;
      case 'power':
        filters.horsePower = ['0 TO ' + filters.power];
        delete filters.power;
        break;
      case 'fuel':
        filters.fuelCode = [String(filters.fuel.fuelCode)];
        delete filters.fuel;
        break;
      case 'color':
        filters.bodyColorCode = [String(filters.color.bodyColorCode)];
        delete filters.color;
        break;
      case 'gear':
        filters.gearCode = [String(filters.gear.gearCode)];
        delete filters.gear;
        break;
      case 'transmission':
        filters.transmissionTypeCode = [String(filters.transmission.transmissionTypeCode)];
        delete filters.transmission;
        break;
      case 'vehicleType':
        filters.vehicleTypeCode = [String(filters.vehicleType.vehicleTypeCode)];
        delete filters.vehicleType;
        break;
      case 'bodyType':
        filters.bodyTypeCode = [String(filters.bodyType.bodyTypeCode)];
        delete filters.bodyType;
        break;
      case 'typeOfUse':
        filters.typeOfUseCode = [String(filters.typeOfUse.typeOfUseCode)];
        delete filters.typeOfUse;
        break;
      case 'wheelBase':
        filters.wheelBaseCode = [String(filters.wheelBase.wheelBaseCode)];
        delete filters.wheelBase;
        break;
      case 'volume':
        if (filters.volume.min === CONFIG.search.volume.min && filters.volume.max === ResultHelper.getUvlVolumeMax()) {
          delete filters.volume;
        } else {
          filters.volume = [
            filters.volume.min + ' TO ' +
            filters.volume.max
          ];
        }
        break;
      case 'doors':
        filters.doors = filters.doors.split(',');
        break;
      case 'vatCode':
        filters.vatCode = [String(filters.vatCode)];
        break;
      case 'damagedVehicle':
        filters.damagedVehicle = [String(filters.damagedVehicle)];
        break;
      case 'brand':
        filters.brandCode = [filters.brand.brandCode];
        delete filters.brand;
        break;
      case 'model':
        if (filters.brand || filters.brandCode) {
          filters.modelCode = [filters.model.modelCode];
          delete filters.model;
        }
        break;
      case 'premium':
        filters.warranty = [CONFIG.search.premium.warrantyCode || '20'];
        delete filters.premium;
        break;
      default:
    }
    return filters;
  }

  function prepareFilters(filters) {
    filters = angular.copy(filters);
    filters = angular.extend(filters, {market: [String(CONFIG.market.code)]});
    if (CONFIG.uvl.additionalFilters && angular.isObject(CONFIG.uvl.additionalFilters)) {
      angular.extend(filters, CONFIG.uvl.additionalFilters);
    }
    angular.forEach(filters, function (value, name) {
      if (value || value === 0) {
        prepareFilter(name, filters);
      } else {
        delete filters[name];
      }
    });
    return filters;
  }

  function getValues(query, fields) {
    query = angular.copy(query);
    var groups = {};
    var order = {};
    var q = {
      filters: {
        brand: query.filters.brand,
        priceCurrent: query.filters.priceCurrent,
        km: query.filters.km,
        registrationYear: query.filters.registrationYear
      },
      extendedArea: query.extendedArea,
      location: query.location,
      fixArea: query.fixArea
    };

    if (query.filters.brand) {
      q.filters = prepareFilters(q.filters);

      if (!query.filters.model) {
        groups.modelCode = {
          fields: ['modelDescription', 'modelCode']
        };
        order.modelDescription = 'asc';
      }
      if (!query.filters.fuel) {
        groups.fuelCode = {
          fields: ['fuelDescription', 'fuelCode']
        };
        order.fuelDescription = 'asc';
      }
      if (!query.filters.gear) {
        groups.gearCode = {
          fields: ['gearDescription', 'gearCode']
        };
        order.gearDescription = 'asc';
      }
      if (!query.filters.color) {
        groups.bodyColorCode = {
          fields: ['bodyColorDescription', 'bodyColorCode']
        };
        order.bodyColorDescription = 'asc';
      }
      if (!query.filters.transmission) {
        groups.transmissionTypeCode = {
          fields: ['transmissionTypeDescription', 'transmissionTypeCode']
        };
        order.transmissionTypeDescription = 'asc';
      }
      if (!query.filters.vehicleType) {
        groups.vehicleType = {
          fields: ['vehicleTypeDescription', 'vehicleTypeCode']
        };
      }
      if (!query.filters.bodyType) {
        groups.bodyTypeCode = {
          fields: ['bodyTypeDescription', 'bodyTypeCode']
        };
      }
      if (!query.filters.typeOfUse) {
        groups.typeOfUseCode = {
          fields: ['typeOfUseDescription', 'typeOfUseCode']
        };
      }
      if (!query.filters.wheelBase) {
        groups.wheelBaseCode = {
          fields: ['wheelBaseDescription', 'wheelBaseCode']
        };
      }
    } else {
      groups.brandCode = {
        fields: ['brandDescription', 'brandCode']
      };
      order.brandDescription = 'asc';
    }

    return prepareRequest(q, fields, groups, order).then(
      function (q) {
        if (!q.query.filters.mandate && CONFIG.search.explicitMandate) {
          return {};
        }
        if (q.query.filters.mandate) {
          q.query.extendedArea = -1;
        }
        return request('/getValues', q);
      });
  }

  function getVehiclesCount(query) {
    query = angular.copy(query);

    query.filters = prepareFilters(query.filters);
    delete query.pagination;
    delete query.order;

    return prepareRequest(query).then(
      function (query) {
        if (!query.query.filters.mandate && CONFIG.search.explicitMandate) {
          ResultHelper.setCount(0);
          return 0;
        } else if (query.query.filters.mandate) {
          query.query.extendedArea = -1;
        }
        return request('/getVehiclesCount', query)
          .then(function (response) {
            ResultHelper.setCount(response.numFound);
            return response.numFound;
          });
      });
  }

  function prepareRequest(query, fields, groups, order) {
    if (!CONFIG.search.explicitMandate) {
      query = buildQuery(query, fields, groups, order);
      return $q.when(query);
    }
    return getMandate(query).then(function (mandate) {
      query = buildQuery(query, fields, groups, order);
      if (mandate && mandate.length) {
        query.query.filters.mandate = mandate || [];
      }
      return query;
    });
  }

  function getVehicles(query) {
    query = angular.copy(query);
    var page = {};
    page.start = 0;
    page.rows = ResultHelper.getCount() || CONFIG.pagination.default;

    delete query.pagination;

    var order = {};
    var orderKey;
    var orderDirection;
    if (query.order) {
      orderKey = query.order.key;
      orderDirection = query.order.direction;
    } else {
      orderKey = CONFIG.order.default.key;
      orderDirection = CONFIG.order.default.direction;
    }
    order[orderKey] = orderDirection;
    if (orderKey === 'registrationYear') {
      order.registrationMonth = orderDirection;
    }
    delete query.order;

    query.filters = prepareFilters(query.filters);

    return prepareRequest(query).then(
      function (query) {
        query.page = page;
        query.order = order;
        if (query.query.filters.mandate) {
          query.query.extendedArea = -1;
        }
        return request('/getVehicles', query)
          .then(function (response) {
            // do not re-order by warranty if the sorting is set by the user
            if (ResultHelper.ordered) {
              return response;
            }
            response.vehicles = mergeSort(response.vehicles, function (a, b) {
              /* eslint-disable eqeqeq */
              if (a.warranty == b.warranty) {
                return 0;
              }
              return a.warranty == CONFIG.search.premium.warrantyCode ? -1 : 1;
              /* eslint-enable eqeqeq */
            });
            return response;
          });
      });
  }

  function getVehicleDetails(vehicleCode) {
    var vehicleCodes = angular.isArray(vehicleCode) ? vehicleCode : [vehicleCode];
    var params = buildQuery({
      filters: {
        vehicleCode: vehicleCodes
      }
    });
    return request('/getVehicleDetails', params)
      .then(function (response) {
        for (var i = 0; i < response.vehicles.length; i++) {
          var vehicle = response.vehicles[i];
          vehicle.hasWLTPdata = vehicle.wltp && vehicle.wltp.length > 0;
          if (vehicle.hasWLTPdata) {
            var map = {};
            for (var j = 0; j < vehicle.wltp.length; j++) {
              var data = vehicle.wltp[j];
              map[data.code.toLowerCase()] = data.description;
            }
            vehicle.wltpMap = map;
            switch (map.iswltp) {
              case '0':
                vehicle.wltpLevel = '[A]';
                break;
              case '1':
                vehicle.wltpLevel = '[B]';
                break;
              case '2':
                vehicle.wltpLevel = '[C]';
                break;
              case '3':
                vehicle.wltpLevel = '[B][C]';
                break;
              default: break;
            }
          }
        }
        return angular.isArray(vehicleCode) ? response.vehicles : response.vehicles[0];
      });
  }

  function getShareUrl(social, vehicle) {
    return baseUrl + '/share?' + $httpParamSerializer({
      scope: 'NET',
      consumer: getConsumer(),
      vehicleCode: vehicle.vehicleCode,
      market: CONFIG.market.id.toUpperCase(),
      language: CONFIG.language.id,
      social: social,
      title: $translate.instant('site_name'),
      siteName: $translate.instant('site_url'),
      brand: CONFIG.brand.id
    });
  }

  function request(method, body) {
    return $http({
      method: 'POST',
      url: baseUrl + method,
      data: body,
      headers: {
        'Content-Type': undefined
      }
    }).then(function (response) {
      if (response.data.errors) {
        return $q.reject(response.data.errors);
      }
      return $q.when(response.data.response);
    });
  }

  function getDealer(brand, sincom, sitecode) {
    var dealerLocatorUrl = CONFIG.dealerLocator.endpoint;
    var params = {
      func: 'finddealerxml',
      brand: brand,
      mkt: CONFIG.market.code,
      sin: sincom,
      st: sitecode
    };
    if (CONFIG.dealerLocator.params && angular.isObject(CONFIG.dealerLocator.params)) {
      angular.extend(params, CONFIG.dealerLocator.params);
    }
    return $http.jsonp($sce.trustAsResourceUrl(dealerLocatorUrl), {
      jsonpCallbackParam: 'jsonp',
      params: params
    }).then(function (response) {
      if (!response.data.results || !angular.isArray(response.data.results)) {
        asyncTasks.error = true;
        return {};
      }
      if (CONFIG.dealerLocator.overrideData) {
        var overrideData = CONFIG.dealerLocator.overrideData[response.data.results[0].SINCOM];
        if (overrideData) {
          response.data.results[0] = angular.extend({}, response.data.results[0], overrideData);
        }
      }
      return response.data.results[0];
    });
  }

  function getImpressum(legalEntity) {
    var url = CONFIG.impressum.endpoint
      .replace(':legalentity', legalEntity)
      .replace(':market', CONFIG.market.id)
      .replace(':language', CONFIG.language.id);

    return $http.get(url)
      .then(function (response) {
        var content = $window.document.createElement('html');
        content.innerHTML = response.data;
        var impressum = content.getElementsByTagName('impressum');
        return impressum.length ? impressum[0].innerHTML : response.data;
      })
      .catch(function () {
        asyncTasks.error = true;
        return null;
      });
  }

  function getMandate(query) {
    return getDealerList(query)
      .then(function (dealers) {
        var mandate = [];
        var mandateMap = {};
        angular.forEach(dealers, function (dealer) {
          var key = dealer.BRAND + '.' + dealer.SINCOM;
          if (!mandateMap[key]) {
            mandateMap[key] = true;
            mandate.push({
              brand: dealer.BRAND,
              dealer: dealer.SINCOM,
              location: '*'
            });
          }
        });
        return mandate;
      });
  }

  function getDealerList(query) {
    var params = {
      func: 'finddealerxml',
      mkt: CONFIG.market.code,
      rad: query.extendedArea,
      x: query.location.geometry.lng,
      y: query.location.geometry.lat
    };
    if (CONFIG.dealerLocator.params && angular.isObject(CONFIG.dealerLocator.params)) {
      angular.extend(params, CONFIG.dealerLocator.params);
    }

    if (query.filters.brandCode) {
      params.brand = String($window.parseInt(query.filters.brandCode[0]));
    } else if (query.filters.brand) {
      params.brand = String($window.parseInt(query.filters.brand.brandCode));
    }

    // Workaround for Fiat
    params.brand = params.brand === '0' ? '00' : params.brand;

    if (lastDealerList && lastDealerList.length && angular.equals(params, lastDealerListParams)) {
      return $q.when(lastDealerList);
    }
    lastDealerListParams = params;

    var dealerLocatorUrl = 'https://dealerlocator.fiat.com/geocall/RestServlet';
    if (CONFIG.dealerLocator && CONFIG.dealerLocator.endpoint) {
      dealerLocatorUrl = CONFIG.dealerLocator.endpoint;
    }
    return $http.jsonp($sce.trustAsResourceUrl(dealerLocatorUrl), {
      jsonpCallbackParam: 'jsonp',
      params: params
    })
      .then(function (response) {
        if (CONFIG.dealerLocator.overrideData) {
          for (var i = 0; i < response.data.results.length; i++) {
            var overrideData = CONFIG.dealerLocator.overrideData[response.data.results[i].SINCOM];
            if (overrideData) {
              response.data.results[i] = angular.extend({}, response.data.results[i], overrideData);
            }
          }
        }
        lastDealerList = response.data.results;
        return lastDealerList;
      });
  }
}
